export default __webpack_public_path__ + "static/media/Capture2.45a933a3.PNG";